module.exports = __webpack_public_path__ + "img/search_black.2b5cdf2e.png";